import type { Nil } from "@mcwd/typescript-type-guards";
import { LanguageCountryLocale } from "../../types-and-definitions/locale-defs/Locales.js";
import { ComputedValueGetter } from "../../utils/ComputedValueGetter.js";

const navigator = globalThis.navigator ?? {};

export function getBrowserPrefferedLanguage (): LanguageCountryLocale | Nil {
  const acceptedLangs = LanguageCountryLocale;
  if ("languages" in navigator) {
    const langs = navigator.languages.filter(l => {
      return (acceptedLangs as readonly string[]).includes(l);
    });
    // If matching multiple languages, no inference can be made, so only return a value if a single language is matched.
    if (langs.length === 1) {
      return langs.shift() as LanguageCountryLocale;
    }
  }
  // Return the primary language if it matches
  if ("language" in navigator && (acceptedLangs as readonly string[]).includes(navigator.language)) {
    return navigator.language as LanguageCountryLocale;
  }
  return null;
}

export const BrowserPreferredLanguage = new ComputedValueGetter({
  isLazy: true,
  computeFn: getBrowserPrefferedLanguage
});